export interface AgentManifest {
  key: string;
  label: string;
  category: string;
  order: number;
}

/**
 * An assistant message is a sequence of parts so prose tokens and structured
 * events (tool calls, errors) can render with different chrome. User messages
 * are always a single text part.
 */
export interface MessagePart {
  id: string;
  kind: "error" | "event" | "text";
  text: string;
}

type Role = "assistant" | "user";

export interface AgentMessage {
  id: string;
  parts: MessagePart[];
  role: Role;
}

export interface AgentEventMessage {
  content: string;
  role: Role;
}

// Prefixes of the events the runtime emits around each tool call:
// "🔧 Calling <tool>..." and "✓ <tool> complete". They mark a seam between the
// agent's pre-tool and post-tool text, even when hidden from the user.
export const TOOL_BOUNDARY_PREFIXES = ["🔧", "✓"] as const;

// Event `data` prefixes that mark runtime diagnostics — noise for end users.
const DEBUG_EVENT_PREFIXES = [
  "♥",
  "🤔",
  "💭",
  ...TOOL_BOUNDARY_PREFIXES,
  "[TOKEN]",
  "[diag]",
  "[tick]",
  "[debug]",
  // Stream lifecycle marker the runtime emits when the response ends; useful
  // for debugging, but noise for end users.
  "Stream ended",
] as const;

export function isDebugEvent(data: string): boolean {
  return DEBUG_EVENT_PREFIXES.some((prefix) => data.startsWith(prefix));
}
